export enum WalletTransferStatus {
  Pending = 6031,
}

export interface WalletTransferInfo {
  chat_id: string;
  cli_msg_id: string;
  chain_id: string;
  chain_type: string;
  transfer_id: string;
  status: number;
}

export interface PullWalletFromCloudParams {
  cloud_data: string;
  local_data: string;
  local_device: string;
}
